export const getGeoObjectData = (GeoObject) => {
  const [lon, lat] = GeoObject.Point.pos.split(' ');
  const title = GeoObject.name;
  const subtitle = GeoObject.description;
  const kind = GeoObject.metaDataProperty.GeocoderMetaData.kind;

  return { lon, lat, title, subtitle, kind };
};
